import { render, staticRenderFns } from "./BaseControlDescription.vue?vue&type=template&id=403c1465&"
import script from "./BaseControlDescription.vue?vue&type=script&lang=js&"
export * from "./BaseControlDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports